import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CrossAppLinkDirective } from './cross-app-link.directive';

@NgModule({
  declarations: [CrossAppLinkDirective],
  exports: [CrossAppLinkDirective],
  imports: [CommonModule],
})
export class CrossAppLinkModule {}
